import React, { PureComponent } from "react";

export default class FetchingArticlesList extends PureComponent {
  render() {
    return (
      <div id="new-community-articles-fetching" className="fetching-v2 grid-x">
        <div className="article-fetching big-article cell small-12 medium-6">
          <div className="article-fetching-author grid-x grid-margin-x">
            <div className="cell small-2">
              <div className="article-fetching-author-logo gradiant" />
            </div>
            <div className="article-fetching-author-infos cell small-10">
              <div className="article-fetching-author-name fetching-color" />
              <div className="article-fetching-author-function fetching-color" />
            </div>
          </div>
          <div
            className="article-fetching-img gradiant"
            style={{ height: "29.5rem" }}
          />
        </div>
        <div className="article-fetching cell small-12 medium-6 grid-x">
          {[1, 2, 3, 4].map(el => (
            <div
              className="article-fetching cell small-12 medium-6"
              key={`article-fetching-${el}`}
            >
              <div className="article-fetching-author grid-x grid-margin-x">
                <div className="cell small-2">
                  <div className="article-fetching-author-logo gradiant" />
                </div>
                <div className="article-fetching-author-infos cell small-10">
                  <div className="article-fetching-author-name fetching-color" />
                  <div className="article-fetching-author-function fetching-color" />
                </div>
              </div>
              <div className="article-fetching-img gradiant" />
            </div>
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Fetching/FetchingArticlesList.js